const BASE_URL = process.env.REACT_APP_BASE_URL;
const API_KEY = process.env.REACT_APP_AWS_FRIENDZ_API_KEY;

/**
 * Get search history for a user
 */
export const getUserSearchHistory = async (userId) => {
  try {
    console.log('Fetching search history for userId:', userId);
    
    const response = await fetch(`${BASE_URL}/search-history?userId=${userId}`, {
      headers: {
        'x-api-key': API_KEY
      }
    });

    console.log('Search history response status:', response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Search history response error:', errorText);
      throw new Error(`HTTP ${response.status}: ${errorText || response.statusText}`);
    }

    const data = await response.json();
    console.log('Search history data received:', data);
    return data.searches || [];
  } catch (error) {
    console.error('Error fetching search history:', error);
    throw error;
  }
};

/**
 * Delete a search entry from history
 */
export const deleteSearchEntry = async (userId, searchTimestamp) => {
  try {
    console.log('Deleting search entry:', { userId, searchTimestamp });
    
    const response = await fetch(`${BASE_URL}/search-history?userId=${userId}&searchTimestamp=${searchTimestamp}`, {
      method: 'DELETE',
      headers: {
        'x-api-key': API_KEY
      }
    });

    console.log('Delete search response status:', response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Delete search response error:', errorText);
      throw new Error(`HTTP ${response.status}: ${errorText || response.statusText}`);
    }

    const data = await response.json();
    console.log('Search entry deleted successfully');
    return data;
  } catch (error) {
    console.error('Error deleting search entry:', error);
    throw error;
  }
};